import { Component, Watch } from 'vue-property-decorator'

import { getTranslatedString, ThesaurusTerm } from '@skinsoft/types'
import { thesaurusTermSelectors } from '@skinsoft/selectors'
import { ThesaurusTermDataStore } from '@skinsoft/entity'
import { ReactiveVue } from '@skinsoft/reactive-vue'

interface Option {
    text: string;
    value: string;
}

@Component({
    props: ['id', 'placeholder'],
    template: require('./thesaurus-term-select-field.html'),
})
export class ThesaurusTermSelectField extends ReactiveVue {
    public $thesaurusTermDataStore: ThesaurusTermDataStore;
    public id: string;
    public placeholder: string;

    public thesaurusTerms: ThesaurusTerm[] = null as any;
    public options: Option[] = null as any;

    public mounted() {
        this.subscribeToThesaurusTerm();
    }

    public beforeDestroy() {
        this.unsubscribeFrom('thesaurusTerm');
    }

    public subscribeToThesaurusTerm() {
        this.subscribeTo(
            this.$thesaurusTermDataStore.fetchChildren(this.id, this.$i18n.locale),
            thesaurusTerms => {
                this.thesaurusTerms = thesaurusTerms;
            },
            'thesaurusTerm',
        );
    }

    @Watch('id')
    private onIdChange() {
        this.unsubscribeFrom('thesaurusTerm');
        this.subscribeToThesaurusTerm();
    }

    @Watch('thesaurusTerms', { deep: true })
    private onThesaurusTermsChange() {
        this.options = this.thesaurusTerms.map(thesaurusTerm => ({
            text: getTranslatedString(thesaurusTermSelectors.preferredTerm(thesaurusTerm), this.$i18n.locale),
            value: thesaurusTerm.id,
        }));

        this.options.unshift({
            text: this.placeholder,
            value: null as any,
        });
    }
}
